import {createReducer} from '@reduxjs/toolkit'
import * as types from './types'

const lookupReducer = createReducer(
  {
    lookupData: {},

    lookingUp: false,
    lookupFailed: false,
    lookupSucceeded: false,
  },
  {
    [types.LOOKUP]: (state, action) => ({
      ...state,      
      lookupData: {
        address: action.payload.address,
        distance: action.payload.distance,
      },

      lookingUp: true,
      lookupFailed: false,
      lookupSucceeded: false,
    }),
    [types.LOOKUP_SUCCESS]: (state, action) => ({
      ...state,
      lookupData: action.lookupData,

      lookingUp: false,
      lookupFailed: false,
      lookupSucceeded: true,
    }),
    [types.LOOKUP_RESET]: (state, action) => ({
      ...state,

      lookingUp: false,
      lookupFailed: false,
      lookupSucceeded: false,
    })
  }
)

export default lookupReducer